var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebook = function SvgFacebook(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "facebook_svg__a",
    width: 22,
    height: 22,
    x: 2,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.102 1.5H23.1v20.872H2.102z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    fillRule: "evenodd",
    d: "M23.1 11.999c0-5.799-4.701-10.5-10.5-10.5S2.1 6.2 2.1 11.999c0 5.24 3.84 9.585 8.86 10.373v-7.338H8.292V12h2.666V9.686c0-2.632 1.568-4.085 3.966-4.085 1.15 0 2.35.205 2.35.205V8.39h-1.323c-1.305 0-1.711.809-1.711 1.64v1.969h2.912l-.466 3.035h-2.446v7.338c5.02-.788 8.859-5.132 8.859-10.373",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.687 15.034 17.153 12H14.24v-1.97c0-.83.406-1.64 1.71-1.64h1.325V5.807s-1.202-.205-2.35-.205c-2.4 0-3.967 1.453-3.967 4.085v2.313H8.293v3.035h2.666v7.338a10.6 10.6 0 0 0 3.282 0v-7.338z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as Icon };
export default "img/element-icons/brands/facebook.2061182.svg";